/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Node } from 'react';

import React from 'react';
import { modelTypesById } from '#src/js/constants/models/modelTypes/index.js';
import SubmitButton from '#components/support/buttons/SubmitButton/index.jsx';
import { pendingHint } from './ModelFormSubmitButton.module.scss';

type Props = {|
  className?: string | null,
  disabled?: boolean,
  modelType: number,
  onClick?: Function | null,
  submitting: boolean,
  pendingProposalCount?: number,
|};

const ModelFormSubmitButton = ({
  className = null,
  disabled = false,
  modelType,
  onClick = null,
  submitting,
  pendingProposalCount = 0,
}: Props): Node => {
  const { runButtonText, runButtonRunningText } = modelTypesById[modelType];
  return (
    <>
      <SubmitButton
        className={className}
        disabled={disabled}
        submitting={submitting}
        submittingText={runButtonRunningText}
        onClick={onClick}
      >
        {runButtonText}
      </SubmitButton>
      {pendingProposalCount > 0 && (
        // Run-gate (UI design §4): directs the user to resolve pending proposals -- the
        // per-section breakdown is already visible in the section nav above. `clear` keeps
        // this on its own line regardless of the button's own float/margin className.
        <p className={`${pendingHint} run-gate-pending-hint`}>
          Review {pendingProposalCount} SP3-AI input{pendingProposalCount === 1 ? '' : 's'} before
          running this model.
        </p>
      )}
    </>
  );
};

export default ModelFormSubmitButton;
